import {Steps, Grid} from "antd";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useLocation, Redirect} from "react-router-dom";
import {routerPath, FORM_STEPS} from "@config";
import {selectCurrentStep, selectFinishedSteps, StepperFormActions} from "@redux";
import {trb} from "@utilities";

import "../StepsLayout.less";

const Step = Steps.Step;

export const FormStepper = React.memo(() => {
    const currentStep = useSelector(selectCurrentStep);
    const lastFinishedStep = useSelector(selectFinishedSteps);
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    
    const [, routeStep] = location.pathname.split(`${routerPath.newKycSme.basePath}/`);
    
    useEffect(() => {
        if (routeStep && currentStep !== Number(routeStep) - 1) {
            dispatch(StepperFormActions.setCurrentStep(Number(routeStep) - 1));
        }
    }, [location.pathname]);
    
    if (routeStep > lastFinishedStep + 1) {
        return <Redirect to={`${routerPath.newKycSme.basePath}/${lastFinishedStep + 1}`}/>;
    }
    
    return (
        <Steps
            current={currentStep}
            labelPlacement="vertical"
            direction="vertical"
        >
            {FORM_STEPS.map((row, rowIndex) => (
                <Step
                    description={trb(row)}
                    key={rowIndex}
                    onStepClick={step => history.push(routerPath.newKycSme[`step${step + 1}`])}
                    disabled={rowIndex >= lastFinishedStep + 1}
                />
            ))}
        </Steps>
    );
});
